module.exports = __webpack_public_path__ + "images/file_icons_v2/wmv-3b06a067c495dc8f35ce657aa5afcb46.svg";